import type { DocMeta } from '@blocksuite/store';

import { Entity } from '../../../framework';
import type { FrameworkProvider } from '../../../framework';
import { LiveData } from '../../../livedata';
import type { DocsStore } from '../stores/docs';

export type DocMode = 'edgeless' | 'page';

export type EdgelessModeHandler = (framework: FrameworkProvider) => void;

let globalEdgelessModeHandler: EdgelessModeHandler | undefined;

export function setEdgelessModeHandler(handler: EdgelessModeHandler) {
  globalEdgelessModeHandler = handler;
}

export class DocRecord extends Entity<{ id: string }> {
  id: string = this.props.id;
  constructor(private readonly docsStore: DocsStore) {
    super();
  }

  meta$ = LiveData.from<Partial<DocMeta>>(
    this.docsStore.watchDocMeta(this.id),
    {}
  );

  setMeta(meta: Partial<DocMeta>): void {
    this.docsStore.setDocMeta(this.id, meta);
  }

  primaryMode$: LiveData<DocMode> = LiveData.from(
    this.docsStore.watchDocPrimaryModeSetting(this.id),
    'page'
  ).map(mode => (mode === 'edgeless' ? 'edgeless' : 'page'));

  setPrimaryMode(mode: DocMode) {
    // Pique Update - Forcing all docs to stay in page mode
    if (mode === 'edgeless') {
      if (this.framework) {
        globalEdgelessModeHandler?.(this.framework);
      }
      return;
    }
    return this.docsStore.setDocPrimaryModeSetting(this.id, mode);
  }

  getPrimaryMode() {
    return this.docsStore.getDocPrimaryModeSetting(this.id);
  }

  moveToTrash() {
    return this.setMeta({ trash: true });
  }

  restoreFromTrash() {
    return this.setMeta({ trash: false });
  }

  title$ = this.meta$.map(meta => meta.title ?? '');

  trash$ = this.meta$.map(meta => meta.trash ?? false);
}
